import { ChevronLeftSVG, ChevronRightSVG } from '@snack-uikit/icons';
import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import Link from 'next/link';
import { PropsWithChildren } from 'react';

import { equals } from '@/utils/common';

import s from './styles.module.scss';

export type Direction = 'prev' | 'next';

type LinkWithArrowProps = {
  direction: Direction;
  href: string;
};

export function LinkWithArrow({ children, direction, href }: PropsWithChildren<LinkWithArrowProps>) {
  const isNext = equals(direction, 'next');
  const Icon = isNext ? ChevronRightSVG : ChevronLeftSVG;

  return (
    <Link className={s.card_wrapper} href={href}>
      <Typography.SansBodyS
        className={cn(s.nav_label, {
          [s.align_text_end]: isNext,
        })}
      >
        {isNext ? 'Следующая статья' : 'Предыдущая статья'}
      </Typography.SansBodyS>
      <div className={cn(s.link_with_arrow_wrapper, { [s.reverse_flex]: isNext })}>
        <Icon className={s.article_text} />
        <Typography.SansLabelL className={s.article_text}> {children} </Typography.SansLabelL>
      </div>
    </Link>
  );
}
